import styled from "styled-components";
import React, { useEffect } from "react";
import PageWrapper from "Components/PageWrapper";
import useDetailData from "Hooks/useDetailData";
import ContainerMd from "Components/Containers/ContainerMd";
import Title, { TitleType } from "Components/Text/Title";
import DetailSection from "Components/Detail/DetailSection";
import Thumbnail from "Components/SourceImage";
import TextParagraph from "Components/Text/TextParagraph";
import Slider from "Components/Slider";
import Gallery from "Components/Gallery";
import DetailUser from "Components/User/DetailUser";
import { useHeaderState } from "Provider/AppProvider";
import useWindowSize from "Hooks/useWindowSize";
import media, { BREAKPOINT_MOBILE } from "Styles/media";
import Footer from "Components/Footer";
import useScrollDir from "Hooks/useScroll";
import { useLocation } from "react-router";
import queryString from "query-string";

const Wrapper = styled(PageWrapper)`
	/* padding-bottom: ${(props) => `${props.theme.size.offset.pc * 2 + props.theme.size.logo.pc}px`}; */
`;

const Caption = styled(TextParagraph)`
	b {
		font-weight: normal;
	}
	padding-bottom: 24px;
`;

const DetailTitle = styled(Title)`
	padding-bottom: 0px;
`;

const LocalSlider = styled(Slider)`
	@media ${media.mobile} {
		.slider-container {
			width: ${(props) => `calc(100% + ${props.theme.size.offset.tablet * 2}px)`};
			left: ${(props) => `${props.theme.size.offset.tablet * -1}px`};
		}
	}
`;

const Planet: React.FC = () => {
	const { size } = useWindowSize();
	const { initHeaderState, setHeaderState } = useHeaderState();
	const { element, value } = useScrollDir();
	const { search } = useLocation();
	const { id } = queryString.parse(search);

	const { data } = useDetailData(`${id}`);

	useEffect(() => {
		initHeaderState();
		return () => {
			initHeaderState();
		};
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (size.width <= BREAKPOINT_MOBILE) {
			if (value > 64) {
				setHeaderState((n) => ({
					...n,
					solid: true
				}));
			} else {
				setHeaderState((n) => ({
					...n,
					solid: false
				}));
			}
		}
	}, [value, setHeaderState, size]);

	return (
		<Wrapper id={"detail-wrapper"} propsRef={element}>
			{data && (
				<>
					{/* cover */}
					<DetailSection>
						<ContainerMd>
							<DetailTitle value={data.title} />
							<Caption value="">
								<b>created_by</b> {data.user.name}
							</Caption>
							<Thumbnail image={data.thumbnail} />
						</ContainerMd>
					</DetailSection>

					{/* scenario */}
					<DetailSection>
						<ContainerMd>
							<Title value={"scenario"} type={TitleType.MD} align="center" div={true} />
							<TextParagraph value={data.descript} />
						</ContainerMd>
					</DetailSection>

					{/* process */}
					<DetailSection>
						<ContainerMd>
							<Title value={"process"} type={TitleType.MD} align="center" div={true} />
							<LocalSlider data={data.process} />
						</ContainerMd>
					</DetailSection>

					{/* zplanet */}
					<DetailSection>
						<ContainerMd>
							<Title value={"zplanet"} type={TitleType.MD} align="center" div={true} />
							<Gallery data={data.result} />
						</ContainerMd>
					</DetailSection>

					{/* hitchhiker */}
					<DetailSection>
						<ContainerMd>
							<Title value={"hitchhiker"} type={TitleType.MD} align="center" div={true} />
							<DetailUser user={data.user} />
						</ContainerMd>
					</DetailSection>
				</>
			)}
			<Footer />
		</Wrapper>
	);
};

export default Planet;
